const Relojes = {
  relojes: [
    {
      id: 1,
      path:"/productos-relojesPared",
      cover: "./images/relojes/1a-reloj.jpg",
      cover1: "./images/relojes/1a-reloj-logo.jpg",
      cover2: "./images/relojes/1a-reloj-colores.jpg",
      name: "Reloj Grande",
      description: "Este reloj de pared es un accesorio moderno y minimalista con bordes negros, hecho de plástico duro, resistente a golpes y caídas. Los números de tamaño normal son fáciles de leer, y funciona con una pila doble A. Fácil de instalar con su soporte para colgar, y su tamaño de 200x200mm lo hace perfecto para cualquier pared estándar. Un producto elegante y funcional para decorar cualquier ambiente.",
      price: "R1",
      discount: "2",
    },
    {
      id: 2,
      path:"/productos-relojesPared",
      cover: "./images/relojes/1b-reloj.jpg",
      cover1: "./images/relojes/1b-reloj-logo.jpg",
      cover2: "./images/relojes/1b-reloj-colores.jpg",
      name: "Reloj Romano",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "R2",
      discount: "2",
    },
    {
      id: 3,
      path:"/productos-relojesPared",
      cover: "./images/relojes/2a-reloj.jpg",
      cover1: "./images/relojes/2a-reloj-logo.jpg",
      cover2: "./images/relojes/2a-reloj-colores.jpg",
      name: "Reloj de Cocacola V1",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "R3",
      discount: "2",
    },
    {
      id: 4,
      path:"/productos-relojesPared",
      cover: "./images/relojes/2b-reloj.jpg",
      cover1: "./images/relojes/2b-reloj-logo.jpg",
      cover2: "./images/relojes/2b-reloj-colores.jpg",
      name: "Reloj de Cocacola V2",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "R4",
      discount: "2",
    },
    {
      id: 5,
      path:"/productos-relojesPared",
      cover: "./images/relojes/3a-reloj.jpg",
      cover1: "./images/relojes/3a-reloj-logo.jpg",
      cover2: "./images/relojes/3a-reloj-colores.jpg",
      name: "Reloj grande",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "R5",
      discount: "2",
    },
    {
      id: 6,
      path:"/productos-relojesPared",
      cover: "./images/relojes/3b-reloj.jpg",
      cover1: "./images/relojes/3b-reloj-logo.jpg",
      cover2: "./images/relojes/3b-reloj-colores.jpg",
      name: "Reloj grande",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "R6",
      discount: "2",
    },
    {
      id: 7,
      path:"/productos-relojesPared",
      cover: "./images/relojes/4a-reloj.jpg",
      cover1: "./images/relojes/4a-reloj-logo.jpg",
      cover2: "./images/relojes/4a-reloj-colores.jpg",
      name: "Reloj grande",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "R7",
      discount: "2",
    },
    {
      id: 8,
      path:"/productos-relojesPared",
      cover: "./images/relojes/4b-reloj.jpg",
      cover1: "./images/relojes/4b-reloj-logo.jpg",
      cover2: "./images/relojes/4b-reloj-colores.jpg",
      name: "Reloj grande",
      description: "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Vitae animi ad minima veritatis dolore. Architecto facere dignissimos voluptate fugit ratione molestias quis quidem exercitationem voluptas.",
      price: "R8",
      discount: "2",
    },
  ],
}
export default Relojes